"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "SubmissionFormdelivery_type" };
var _hoisted_2 = /*#__PURE__*/ vue_2.createElementVNode("span", null, null, -1);
var _hoisted_3 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "heading2" }, "Тип доставки", -1);
var _hoisted_4 = { class: "button-tabs-container" };
var _hoisted_5 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "button-tabs__icon" }, [
    /*#__PURE__*/ vue_2.createElementVNode("i", { class: "termi-truck" })
], -1);
var _hoisted_6 = /*#__PURE__*/ vue_2.createElementVNode("div", null, "Доставка", -1);
var _hoisted_7 = [
    _hoisted_5,
    _hoisted_6
];
var _hoisted_8 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "button-tabs__icon" }, [
    /*#__PURE__*/ vue_2.createElementVNode("i", { class: "termi-truck-loading" })
], -1);
var _hoisted_9 = /*#__PURE__*/ vue_2.createElementVNode("div", null, "Самовывоз", -1);
var _hoisted_10 = [
    _hoisted_8,
    _hoisted_9
];
var _hoisted_11 = /*#__PURE__*/ vue_2.createElementVNode("p", null, [
    /*#__PURE__*/ vue_2.createTextVNode("Стоимость доставки уточняйте у менеджера. При заказе на сумму от "),
    /*#__PURE__*/ vue_2.createElementVNode("b", null, "50 000 ₽"),
    /*#__PURE__*/ vue_2.createTextVNode(" доставка по Москве в пределах МКАД осуществляется бесплатно.")
], -1);
var _hoisted_12 = { class: "submission-form__inputs" };
var _hoisted_13 = { class: "submission-form__grid-2" };
var _hoisted_14 = ["checked"];
var _hoisted_15 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "checkbox" }, [
    /*#__PURE__*/ vue_2.createElementVNode("i", { class: "termi-circle-checkmark" })
], -1);
var _hoisted_16 = /*#__PURE__*/ vue_2.createTextVNode(" Новый адрес ");
var _hoisted_17 = ["checked", "disabled"];
var _hoisted_18 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "checkbox" }, [
    /*#__PURE__*/ vue_2.createElementVNode("i", { class: "termi-circle-checkmark" })
], -1);
var _hoisted_19 = /*#__PURE__*/ vue_2.createTextVNode(" Сохраненный адрес ");
var vue_3 = require("vue");
var Map_vue_1 = require("@/components/Map.vue");
var vuex_1 = require("vuex");
var Select_vue_1 = require("vue_components/Select.vue");
var Address_vue_1 = require("@/components/SubmissionForm/Address.vue");
exports.default = vue_1.defineComponent({
    props: {
        delivery_type: null,
        delivery_address: null,
        address_saved: { type: Boolean }
    },
    emits: ['update:delivery_type', 'update:delivery_address', 'update:address_saved'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var store = vuex_1.useStore();
        var selectedAddressIndex = vue_3.ref(-1);
        var selectAddressOptions = vue_3.computed(function () {
            var arr = [];
            var address = store.state.user.address;
            for (var key in address) {
                arr.push({ name: address[key].value });
            }
            return arr;
        });
        function selectAddress(index) {
            if (index === -1) {
                emit('update:delivery_address', '');
            }
            else {
                emit('update:delivery_address', store.state.user.address[index].value);
            }
        }
        var selectedStoreIndex = vue_3.ref(-1);
        var computedStores = vue_3.computed(function () {
            return store.state.formData.stores.map(function (i) { return ({
                name: i.address
            }); });
        });
        function updateSelect(index) {
            var v;
            if (index === -1) {
                v = '';
            }
            else {
                v = store.state.formData.stores[index].address;
            }
            emit('update:delivery_address', v);
        }
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _hoisted_3,
                vue_2.createElementVNode("div", _hoisted_4, [
                    vue_2.createElementVNode("div", {
                        class: vue_2.normalizeClass(["button-tabs", { 'toggled': props.delivery_type === '24' }]),
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (emit('update:delivery_type', '24')); })
                    }, _hoisted_7, 2),
                    vue_2.createElementVNode("div", {
                        class: vue_2.normalizeClass(["button-tabs", { 'toggled': props.delivery_type === '23' }]),
                        onClick: _cache[1] || (_cache[1] = function ($event) { return (emit('update:delivery_type', '23')); })
                    }, _hoisted_10, 2)
                ]),
                (props.delivery_type === '24')
                    ? (vue_2.openBlock(), vue_2.createElementBlock(vue_2.Fragment, { key: 0 }, [
                        _hoisted_11,
                        vue_2.createElementVNode("div", _hoisted_12, [
                            vue_2.createElementVNode("div", _hoisted_13, [
                                vue_2.createElementVNode("label", {
                                    onClick: _cache[2] || (_cache[2] = function ($event) { return (emit('update:address_saved', false)); }),
                                    class: "checkbox-radio"
                                }, [
                                    vue_2.createElementVNode("input", {
                                        type: "radio",
                                        checked: props.address_saved === false,
                                        name: "address_saved"
                                    }, null, 8, _hoisted_14),
                                    _hoisted_15,
                                    _hoisted_16
                                ]),
                                vue_2.createElementVNode("label", {
                                    onClick: _cache[3] || (_cache[3] = function ($event) { return (Object.keys(vue_2.unref(store).state.user.address).length === 0 ? false : emit('update:address_saved', true)); }),
                                    class: "checkbox-radio"
                                }, [
                                    vue_2.createElementVNode("input", {
                                        type: "radio",
                                        checked: props.address_saved === true,
                                        name: "address_saved",
                                        disabled: Object.keys(vue_2.unref(store).state.user.address).length === 0
                                    }, null, 8, _hoisted_17),
                                    _hoisted_18,
                                    _hoisted_19
                                ])
                            ]),
                            (props.address_saved)
                                ? (vue_2.openBlock(), vue_2.createBlock(Select_vue_1.default, {
                                    key: 0,
                                    title: "Сохраненный адрес",
                                    defaultName: "Не выбран",
                                    modelValue: selectedAddressIndex.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((selectedAddressIndex).value = $event); }),
                                    options: vue_2.unref(selectAddressOptions),
                                    onChange: selectAddress
                                }, null, 8, ["modelValue", "options"]))
                                : (vue_2.openBlock(), vue_2.createBlock(Address_vue_1.default, {
                                    key: 1,
                                    onUpdate: _cache[5] || (_cache[5] = function ($event) { return (emit('update:delivery_address', $event)); })
                                }))
                        ])
                    ], 64))
                    : vue_2.createCommentVNode("", true),
                (props.delivery_type === '23')
                    ? (vue_2.openBlock(), vue_2.createElementBlock(vue_2.Fragment, { key: 1 }, [
                        vue_2.createVNode(Select_vue_1.default, {
                            title: "Пункт самовывоза",
                            defaultName: "Не выбран",
                            options: vue_2.unref(computedStores),
                            modelValue: selectedStoreIndex.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((selectedStoreIndex).value = $event); }),
                            onChange: updateSelect
                        }, null, 8, ["options", "modelValue"]),
                        vue_2.createVNode(Map_vue_1.default, {
                            marks: vue_2.unref(store).state.formData.stores.length ? vue_2.unref(store).state.formData.stores : undefined,
                            currentMark: _ctx.selfAddressIndex
                        }, null, 8, ["marks", "currentMark"])
                    ], 64))
                    : vue_2.createCommentVNode("", true)
            ]));
        };
    }
});
